import {ArrowLeft} from "react-feather";
import {useTheme} from "styled-components";
import {useNavigate} from "react-router-dom";
import {useAppSelector, useBreakpoints} from "hooks";
import {Brand, Button, Column, Row, Typography} from "components";

interface Page404Props {}

export const Page404: React.FC<Page404Props> = () => {
  const push = useNavigate();
  const {white} = useTheme();
  const {upSm} = useBreakpoints();
  const {isLogged} = useAppSelector("auth");

  return (
    <Column
      gap={0}
      alignItems="center"
      padding={upSm ? "4rem 1rem" : "2rem 1rem"}
    >
      <Row gap={0}>
        <Brand height={100} filter="grayscale(100%)" />
        <Typography
          color="#444444"
          fontSize={upSm ? 80 : 60}
          fontFamily="Rubik-SemiBold"
        >
          404
        </Typography>
      </Row>
      <Typography textAlign="center" color="#444444" fontSize={upSm ? 20 : 17}>
        La página que intentas acceder no existe
      </Typography>
      <Button
        label="Ir al inicio"
        style={{marginTop: 20}}
        onClick={() => push(isLogged ? "/resume" : "/")}
        leftIcon={<ArrowLeft size={18} color={white} />}
      />
    </Column>
  );
};
